"use strict";
var Observable_1 = require('../../Observable');
var bindCallback_1 = require('../../observable/bindCallback');
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/~/rxjs/add/observable/bindCallback.js
// module id = ../../../../rxjs/add/observable/bindCallback.js
// module chunks = 27